import { render, staticRenderFns } from "./salesVolumeDetails.vue?vue&type=template&id=547194b7&scoped=true&"
import script from "./salesVolumeDetails.vue?vue&type=script&lang=js&"
export * from "./salesVolumeDetails.vue?vue&type=script&lang=js&"
import style0 from "./salesVolumeDetails.vue?vue&type=style&index=0&id=547194b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547194b7",
  null
  
)

component.options.__file = "salesVolumeDetails.vue"
export default component.exports